import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";

interface DeleteAccountResponse {
  message: string;
  social_account_id: number;
  account_type: string;
}

export const useDeleteAccount = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      accountId,
      isAddon,
    }: {
      accountId: string | number;
      isAddon: boolean;
    }) => {
      const url = `${API_CONFIG.path.deleteSocialAccount}/${accountId}`;
      return httpService.delete<DeleteAccountResponse>(url, {
        addon: isAddon ? "true" : "",
      });
    },
    onSuccess: () => {
      // Invalidate and refetch integrations after successful deletion
      queryClient.invalidateQueries({ queryKey: ["integrations"] });
    },
  });
};
